import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SituationFamiliale } from 'src/app/shared/models/situationFamiliale';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SituationFamilialeModalAjoutComponent } from '../modal/situationFamiliale-modal-ajout/situationFamiliale-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { SituationFamilialeModalDetailComponent } from '../modal/situationFamiliale-modal-detail/situationFamiliale-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-situationFamiliale',
	templateUrl: './list-situationFamiliale.component.html',
	styleUrls: ['./list-situationFamiliale.component.scss']
})
export class ListSituationFamilialeComponent implements OnInit {
	situationFamiliale: SituationFamiliale[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	situationFamilialeCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editSituationFamilialeModalRef: BsModalRef;
	addSituationFamilialeModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getSituationFamiliale();
		this.isAddable = true;
	}

	getSituationFamiliale(): void {
		this.isListingLoading = true;
		this.facade.situationFamilialeService.getAllSituationFamiliale().subscribe({
			next: (val) => {
				this.situationFamiliale = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.situationFamiliale.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.situationFamiliale = [];
			}
		});
	}

	selectSituationFamiliale(situationFamiliale: SituationFamiliale): void {
		const link = ['/situationFamiliale', situationFamiliale.id];
		this.router.navigate(link);
	}

	importSituationFamiliale(event: any): void {
		this.situationFamilialeCsvFile = event.target.files[0];

		this.facade.situationFamilialeService
			.importSituationFamiliale(this.situationFamilialeCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} situationFamiliale ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getSituationFamiliale();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addSituationFamilialeModalRef = this.modalService.show(
			SituationFamilialeModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addSituationFamilialeModalRef.onHide.subscribe((reason: string | any) => {
			this.getSituationFamiliale();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(situationFamiliale: SituationFamiliale) {
		const initialState = {
			situationFamiliale: situationFamiliale
		};
		this.editSituationFamilialeModalRef = this.modalService.show(
			SituationFamilialeModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editSituationFamilialeModalRef.onHide.subscribe((reason: string | any) => {
			this.getSituationFamiliale();
		});
	}
}
